<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
			
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 編號" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="比賽名稱" class="mb-0">
							<el-input size="small" v-model="from.title" placeholder="搜索比賽名稱"></el-input>
						</el-form-item>
						<el-form-item label="編號" class="mb-0">
							<el-input size="small" v-model="from.com_no" placeholder="搜索編號"></el-input>
						</el-form-item>
						
					
						<el-form-item label="類型">
							<el-select v-model="from.type" size="small" placeholder="請選擇類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="報名" :value="1"></el-option>
								<el-option label="獎品" :value="2"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>
		<div>	
			<div style="margin-bottom: 20px; padding: 10px; border: 1px solid #e4e4e4; border-radius: 5px;">
						<div style="margin-bottom: 10px; font-weight: bold;">選擇支付方式:</div>
						<el-radio-group v-model="selectedPaymentMethod">
							<el-radio label="paypal">PayPal</el-radio>
							<el-radio label="bank_transfer">銀行轉賬</el-radio>
							<el-radio label="payMe">PayMe</el-radio>
						</el-radio-group>
					</div>

				<!-- 顶部選擇信息和提交按钮 -->
				<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
					<!-- 顯示當前選擇的數量和總金額 -->
					<div>
					已選擇人數: {{ selectedCount }} 人，合計支付金額: <span class="money_text">{{ totalAmount }}</span> 元
					</div>
					<!-- 提交按钮 -->
					 <div><el-button  @click="remove()" >清空購物車</el-button>
						<el-button type="primary" @click="submitSelection(2)" :disabled="isSubmitting">支付</el-button></div>
					
				</div></div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChanges">
				<el-table-column type="selection" width="45" align="center">
				</el-table-column>

				<el-table-column align="center" prop="user_no" label="學生編號">
				</el-table-column>

				<el-table-column align="center" prop="user_name" label="學生名稱">
				</el-table-column>

				<el-table-column align="center" prop="com_no" label="比賽編號">
				</el-table-column>

				<el-table-column align="center" prop="title" label="比賽名稱">
				</el-table-column>

				<el-table-column align="center" prop="ci_name" label="組別">
				</el-table-column>

				<el-table-column align="center" prop="type" label="類型">
					<template slot-scope="v">
						<el-tag v-if="v.row.type==1" >報名</el-tag>
						<el-tag v-if="v.row.type==2" >獎品</el-tag>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="discount_money" label="優惠金額">
				</el-table-column>

				<el-table-column align="center" prop="name" label="獎品名稱">
				</el-table-column>

				<el-table-column align="center" prop="money" label="金額">
				</el-table-column>

				<el-table-column align="center" prop="postage" label="郵費">
				</el-table-column>

				<el-table-column align="center" prop="total_money" label="需支付金額">
				</el-table-column>

				<el-table-column prop="id" align="center" width="100" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<!-- 支付狀態弹窗 -->
		<el-dialog
				:close-on-click-modal="false"
				title="支付狀態"
				:visible.sync="pyaOrderDialog"
				top="5vh"
				:width="layout.is_phone ? '90%' : '60%'"
				@close="closeDialogPay"
				class="dialogClass"
				>
				<div style="text-align: center; margin-top: 20px;">
					<!-- 支付中 -->
					<div v-if="paymentStatus === ''">
					<p style="color: red; font-weight: bold;">支付進行中！</p>
					<p>請於PayPal畫面進行支付手續… …</p>
					<p><img src="../../assets/jingao.png" alt="Logo" style=" height: auto;"><span style="color: red; font-weight: bold;">請勿關閉或刷新此頁面</span>，以免影響交易過程，導致支付失敗或訂單異常。</p>
					<p>剩餘支付時間：
						<span style="color: red; font-weight: bold;">
						{{ formattedCountdown }}
						</span>
					</p>
					<p>訂單處理時間可能需要幾秒鐘至數分鐘，請保持耐心。如支付長時間未完成，請檢查您的網絡狀態或與您的支付平台聯繫。
						</p>
						<p>如有任何問題，請使用郵件功能聯絡我們的客服團隊，我們將竭誠為您服務！</p>
					</div>

					<!-- 支付成功 -->
					<div v-else-if="paymentStatus === 'success'">
					<p style="color: red; font-weight: bold;">支付成功！</p>
						<p>感謝您的支持！您的支付已成功完成，PayPal已收到您的訂單付款。</p>
						<p>訂單詳情：</p>
						<ul>
							<li style="color: red; font-weight: bold;">訂單編號： {{paymentInfo.order_no}}</li>
							<li>支付方式： PayPal 信用卡</li>
							<li style="color: red; font-weight: bold;">支付金額： 港幣 {{paymentInfo.total_money}} 元</li>
						</ul>
						<p>我們將盡快處理您的訂單，並在發貨後透過電子郵件或訊息通知您物流資訊。您可以隨時登入帳戶查詢訂單狀態。</p>
						<p>如有任何疑問，請隨時使用系統郵件聯絡我們的客服團隊！</p>
					</div>

					<!-- 支付失敗 -->
					<div v-else-if="paymentStatus === 'failure'">
					<p style="color: red; font-weight: bold;">支付失敗！</p>
						<p>我們發現您的支付過程未能成功完成，可能是由以下原因導致：</p>
						<ul>
							<li>信用卡或支付方式資訊輸入錯誤</li>
							<li>銀行或支付平台暫時無法處理交易</li>
							<li>付款授權失敗或餘額不足</li>
							<li>網絡連線問題導致支付中斷</li>
						</ul>
						<p><span style="color: red; font-weight: bold;">請您確認支付資訊是否正確，或稍後重新嘗試付款。</span> 如果問題仍然存在，建議您與您的銀行或支付平台PayPal聯繫，了解詳情。</p>
						<p>如需進一步協助，請使用郵件功能聯絡我們的客服團隊，我們將樂意為您解決問題！</p>
					</div>

					<!-- 支付超时 -->
					<div v-else-if="paymentStatus === 'timeout'">
						<p style="color: red; font-weight: bold;">支付超時！</p>
						<p >您的支付請求已超過<span style=" font-weight: bold;">10分鐘限時</span>，因此系統 <span style="color: red; font-weight: bold;">已自動取消您的訂單</span>。</p>
						<p>可能的原因包括：</p>
						<ul>
							<li>您未在限時內完成支付</li>
							<li>支付過程中遇到網絡或系統問題</li>
						</ul>
						<p>如您仍希望重新下單，請重新操作並在支付時留意限時規則，以確保交易順利完成。</p>
						<p>如有任何疑問，請使用郵件功能聯絡我們的客服團隊，我們將樂意為您提供協助！</p>
					</div>
				</div>

				<!-- 底部按钮 -->
				<span slot="footer" class="dialog-footer">
					<!-- 支付成功的確認按钮 -->
					<el-button
					v-if="paymentStatus === 'success'"
					type="default"
					@click="closeDialogPaySuccess"
					>
					確定
					</el-button>


					<!-- 支付中和其他狀態的返回按钮 -->
					<el-button
					v-else
					type="default"
					@click="closeDialogPay"
					>
					返回
					</el-button>
				</span>
				</el-dialog>

		<el-dialog  :close-on-click-modal="false"  :title="selectedPaymentMethod === 'payMe' ? 'PayMe 信息' : '銀行轉賬信息'" :visible.sync="showBankInfo" :before-close="handleDialogClose" width="50%">
				<div >
					<div style="font-size: 16px;font-weight: 700;">
						<div >
							<strong>交易編號：</strong> {{  bankInfo.order_no}}
						</div>
						<div >
							<strong>交易金額：</strong> HKD {{  bankInfo.money}}
						</div>
					</div>
					
					<p style="color: #007cd6;"><span style="margin-right: 5px;font-size: 16px;">※</span>以下為銀行賬號訊息:</p>
					<div style="margin-left: 10px;">
						<div>
							<label style="width: 100px;text-align: right;margin: 0;">銀行名稱</label> ：{{ bankInfo.bankName }}
						</div>
						<div>
							<label style="width: 100px;text-align: right;margin: 0;">收款戶口</label> ：{{ bankInfo.bankUserId }}
						</div>
						<div >
							<label style="width: 100px;text-align: right;margin: 0;">收款人</label> ：{{ bankInfo.bankUserName }}
						</div>
						<div style="color: red;font-weight: 600;">
							<label style="width: 100px;text-align: right;margin: 0;">轉數快</label> ：{{ bankInfo.bankAccount }}
						</div>
					</div>
					<p style="margin: 20px 0 0 0;">-----------------------------------------------------------</p>
					<p style="color: #007cd6;"><span style="margin-right: 5px;font-size: 16px;">※</span> 完成轉賬後，請截圖至<span style="color: red;">{{  bankInfo.ins_name}}</span> 。</p>
					<div style="margin-left: 10px;margin-bottom: 10px;">
						<label style="width: 100px;text-align: right;font-weight: 600;">電郵地址</label> : {{ bankInfo.bankEmail }}
					</div>
					
					<!-- 图片并排 -->
					<div v-if="bankInfo.bankWhatsApp || bankInfo.bankWx" style="margin-left: 10px;display: flex; gap: 20px; margin-bottom: 10px;">
						<div v-if="bankInfo.bankWhatsApp" style="text-align: center;width: 50%;">
							
							<img :src="bankInfo.bankWhatsApp" alt="WhatsApp QR Code" style="width: 150px; height: 150px; display: block;margin: 0 auto;" />
							<strong><img width="20px" src="../../assets/phoneicon.png" alt=""> {{bankInfo.whatsapp}}</strong>
						</div>
						<div v-if="bankInfo.bankWx" style="text-align: center;width: 50%;">
							<img :src="bankInfo.bankWx" alt="WeChat QR Code" style="width: 150px; height: 150px; display: block;margin: 0 auto;" />
							<strong><img width="20px" src="../../assets/vx.png" alt=""> {{bankInfo.vx}}</strong>
						</div>
					</div>
					<div style="width: 100%;height: 58px;border: 1px solid #333333;padding: 5px;">
						{{ bankInfo.content }}
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="handlePaymentComplete">返回</el-button>
				</div>
			</el-dialog>
		
	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';

	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				
				selectedPaymentMethod: 'paypal', // 默認選擇 PayPal
				selectedUsers: [] ,// 选中的用戶數据
				showBankInfo: false, // 是否顯示银行信息对话框
				isSubmitting: false, // 是否正在提交，控制按钮狀態

				pyaOrderDialog: false, // 控制弹框顯示
				countdown: 600, // 倒计时秒數
				timer: null, // 定时器
				paymentStatus: '', // 支付狀態，success 或 failure
				paymentInfo:[],

				
				//搜索數据
				from: {
					type: -1,
					title: '',
					com_no: '',
				},
				model_title: 'Notice',
				auth_val: 'Notice',
				preUrl: "data/UserCart", //列表地址
				delUrl: "data/delOrderCart", //删除單条

				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
				},

				pay_type: undefined, // 提交時傳入，用於銀行轉賬/PayMe 分支判斷

				bankInfo: {
					bankName: '',
					bankUserName: '',
					bankUserId: '',
					bankEmail: '',
					bankWhatsApp: '',
					bankWx: '',
					bankAccount: '',
					vx: '',
					whatsapp: '',
					ins_name: '',
					money: 0,
					order_no: '',
				},

				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
			}
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state

			formattedCountdown() {
				// 格式化倒计时为分钟:秒
				const minutes = Math.floor(this.countdown / 60);
				const seconds = this.countdown % 60;
				return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
			},
			scrollToTop() {
				// 獲取滾動容器並設置滾動條位置
				const content = this.$refs.dialogContent;
				if (content) {
				content.scrollTop = 0; // 將滾動條設置到頂端
				}
			},
			

			// 计算选中的人數
			selectedCount() {
				return this.selectedUsers.length;
			},

			// 计算合计金額
			totalAmount() {
				let sum = 0;
				if (this.selectedUsers && this.selectedUsers.length > 0) {
					this.selectedUsers.forEach(user => {
						sum += Number(user.total_money || 0);
					});
				}
				return sum;
			},
			
			
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		watch: {
			pyaOrderDialog(val) {
				if (val) {
					this.paymentStatus = '';
					this.startCountdown(); // 开始倒计时
					// this.simulateWebSocket(); // 模拟 WebSocket
				} else {
					clearInterval(this.timer);
					this.timer = null;
				}
			},
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		mounted() {
			// 监听来自 layout 的 `payStatus` 事件
			this.layout.$on('payStatus', (data) => {
				this.checkPaymentStatus(data);
			});
			this.layout.$on('payStatusSchool', (data) => {
				this.handleWebSocketNotification(data);
			});
		},
		methods: {
			remove() {
				this.$confirm('確定要清空購物車嗎？', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 用戶點擊了確定，執行刪除操作
					this.axios.post('/admin/data/UserCartRemove', {}, {
						token: true,
					}).then(res => {
						const all = res.data;
						this.isSubmitting = false;
						this.getList()
						this.layout.getPageNum();
					}).catch(err => {
						this.isSubmitting = false;
						this.getList()
						this.layout.getPageNum();
						this.$message.error("提交失敗，請稍後再試");
					});
				}).catch(() => {
					// 用戶點擊了取消，不執行刪除操作
					this.$message({
						type: 'info',
						message: '已取消清空'
					});
				});
			},
			//paypal支付-------

			closeDialogPaySuccess() {
				this.handlePaymentComplete()
			},
			closeDialogPay() {
				this.isSubmitting = false;
				this.pyaOrderDialog = false;
				clearInterval(this.timer);
			},
			startCountdown() {
				this.countdown = 600; // 初始化倒计时
				this.timer = setInterval(() => {
					if (this.countdown > 0) {
					this.countdown--;
					} else {
					this.handleTimeout();
					}
				}, 1000);
			},
			handleTimeout() {
				clearInterval(this.timer);
				if (!this.paymentStatus) {
					this.paymentStatus = 'timeout'; // 倒计时结束默認失敗
				}
			},
			handleWebSocketNotification(status) {
			// WebSocket 收到支付狀態通知
				clearInterval(this.timer);
				if (status['msg'] === 'success') {
					this.paymentStatus = 'success';
					this.paymentInfo = status;
				} else if (status['msg'] === 'failure') {
					this.paymentStatus = 'failure';
				}
			},
			checkPaymentStatus(status) {
				// 检查支付结果
				if (status == 1) { // 假设後台返回的 status 中有 success 表示支付成功
					this.$message.success("支付成功！");
				} else {
					this.$message.error("支付失敗或超时，請重試。");
				}
				this.payloading= false;
				this.isCheckingPayment = false; // 隐藏进度条
				this.createPayModel = false; // 關閉对话框
				this.layout.getPageNum();
				this.getList()
            },
			//paypal支付-------


			//支付公用----
			handlePaymentComplete() {
				this.isSubmitting = false;
				this.payloading = false;
				this.pyaOrderDialog = false;
				this.createUserModel = false; // 關閉添加學生的对话框
				this.pyaOrderModel = false; // 關閉添加學生的对话框
				this.FenModel = false; // 關閉添加學生的对话框
				this.showBankInfo = false; // 關閉银行信息的对话框
				this.layout.getPageNum();
				this.getList()
			},
			//支付公用----

			handleDialogClose(done) {
				// 调用支付完成處理逻辑
				this.handlePaymentComplete();
			},
			// 提交选中的數据（payType 可選，用於銀行轉賬/PayMe 等分支判斷）
			submitSelection(payType) {
				if (this.selectedUsers.length == 0) {
					this.$message.warning("請先選擇訂單");
					return;
				}

				this.isSubmitting = true;
				this.pay_type = payType; // 供下方 list.status 分支使用
				const post = {
					pay_type: this.selectedPaymentMethod,
					com_id: this.com_info_user_id,
					user: this.selectedUsers
				};

				this.axios.post('/admin/data/UserCartShopping', post, {
					token: true,
				}).then(res => {
					const all = res.data;
					if(all.code == 1){
						const list = all.data.list;
						if (list.status == 2) {
							// PayPal 支付逻辑
							if (!this.layout.webSocket || this.layout.webSocket.readyState !== WebSocket.OPEN) {
								this.layout.initSocket(); // 如果 WebSocket 未连接，则重新初始化连接
							}
							if (list.url) {
								// 在新窗口打开支付页面
								this.pyaOrderDialog = true;
								window.open(list.url, '_blank');
							} else {
								this.$message.warning("操作失敗");
							}
						} else if (this.selectedPaymentMethod === "bank_transfer" || this.selectedPaymentMethod === "payMe") {
							if(this.pay_type == 1 || list.status == 3){
								this.$message({
										message: '操作完成',
										type: 'success'
									}); // 控制是否顯示成功提示
								this.handlePaymentComplete()
							}else{
								// 銀行轉賬 / PayMe：僅展示信息，流程一致
								this.bankInfo = {
									bankName: list.data.bank_name,
									bankUserName: list.data.bank_user_name,
									bankUserId: list.data.bank_user_id,
									bankEmail: list.data.bank_email,
									content: list.data.content,
									bankWhatsApp: list.data.bank_whatsapp,
									bankWx: list.data.bank_wx,
									bankAccount: list.data.bank_account,
									vx: list.data.vx,
									whatsapp: list.data.whatsapp,
									ins_name: list.data.ins_name,
									money: list.data.money,
									order_no: list.data.order_no,
								};
								
								this.showBankInfo = true; // 顯示银行/ PayMe 信息对话框
							}
						} else {
							this.$message({
										message: '操作完成',
										type: 'success'
									}); // 控制是否顯示成功提示
							this.isSubmitting = false;
							// this.pyaOrderDialog = false;
							this.createUserModel = false; // 關閉对话框
							this.layout.getPageNum();
							this.getList(); // 刷新數据
						}
					}else{
						this.isSubmitting = false;
					}
					
				}).catch(err => {
					// this.pyaOrderDialog = false;
					this.isSubmitting = false;
					this.$message.error("提交失敗，請稍後再試");
				});
			},

			// 處理選擇变化
			handleSelectionChanges(selection) {
				this.selectedUsers = selection;
			},
			reply(e){
				// 初始化表單數據
				this.form = {
					id: e.row.id,
					ins_id: e.row.ins_id,
					title: e.row.title,
					email_no: e.row.email_no,
					create_time: e.row.create_time,
					content: e.row.content,
					local: e.row.local,
					email: e.row.email,
					phone: e.row.phone,
					sender_name: e.row.sender_name,
					type: e.row.type,
					admin_type: 2,
					reply_content: '',
					reply_title: '',
				};
				this.editIndex = e.row.id;
				this.createModel = true;
			},
			 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			openDialog(row,type) {
				if(type == 2){
					this.dialogContent = row.reply_content; // 设置要顯示的 HTML 内容
				}else{
					this.dialogContent = row.content; // 设置要顯示的 HTML 内容
				}
				
				this.dialogType = type; // 设置要顯示的 HTML 内容
				this.emailTitle = row.title; // 设置要顯示的 HTML 内容
				this.senderName = row.sender_name; // 设置要顯示的 HTML 内容
				this.sendTime = row.create_time; // 设置要顯示的 HTML 内容
			
				if(row.status == 0){
					this.changeStatus(row,1,false,true)
				}
				this.dialogVisible = true;    // 顯示对话框
			},
			closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
			},
			

			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.layout.getPageNum();
				this.getList()
			},
			sortChange(column) {
				this.prop = column.prop
				this.sort = column.order
				this.layout.getPageNum();
				this.getList()
			},
			//提交
			submit() {
				this.$refs.formEdit.validate(res => {
					if (res) {
                   
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					type: -1,
					title: '',
					com_no: '',
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.layout.getPageNum();
				this.getList()
			},
			
		}
	}
</script>

<style>
.dialog-header {
  border-bottom: 1px solid #ebeef5;
  padding: 10px 20px;
  margin-bottom: 15px;
}

.email-info p {
  margin: 0;
  font-size: 14px;
  color: #606266;
}

.dialog-content {
  padding: 10px 20px;
}
/* 对话框整体样式 */
.custom-dialog {
  border-radius: 8px; /* 圆角边框 */
  overflow: hidden; /* 防止溢出 */
}

/* 顶部信息样式 */
.dialog-header {
  padding: 15px 20px;
  background-color: #f5f7fa; /* 添加背景色 */
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 15px;
}

.email-info p {
  margin: 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
}

/* 輸入框样式 */
.form-input {
  width: 100%;
  margin-bottom: 10px;
}

/* 底部按钮样式 */
.dialog-footer {
  padding: 10px 20px;
  text-align: right;
}

.dialog-footer .el-button:first-child {
  margin-right: 10px;
}

/* 改进按钮样式 */
.el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
}
.el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

/* 限制郵件内容高度並添加滾動條 */
.email-content {
  max-height: 100px; /* 限制高度 */
  overflow-y: auto; /* 添加垂直滾動條 */
  word-break: break-word; /* 避免內容溢出 */
  padding: 5px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f9f9f9;
}
</style>
